import { useEffect, useRef } from 'react';
import { FUNC_HASH_CONV, FUNC_HASH_MAIN } from '@/pages/function/constants/index';
import { useLocation } from 'react-router';
import { NAV_PATH } from '@/router/constants';

const useTabManager = () => {
	const funcSelectedIndexRef = useRef(0);
	const currentListTypeRef = useRef<'main' | 'conv'>('main');
	const location = useLocation();

	// 해시가 변경될 때 실행
	const funcChangeHashHandler = () => {
		const locHash = window.location.hash.replace('#', '');
		let selectedIndex = -1;
		let selectedList = FUNC_HASH_MAIN;
		const listType: 'main' | 'conv' = location.pathname === NAV_PATH.FUNCTION.CONVENIENCE ? 'conv' : 'main';

		if (listType === 'conv') {
			selectedIndex = FUNC_HASH_CONV.indexOf(locHash);
			selectedList = FUNC_HASH_CONV;
		} else {
			selectedIndex = FUNC_HASH_MAIN.indexOf(locHash);
		}

		if (selectedIndex === -1) {
			selectedIndex = 0;
			selectedList = listType === 'conv' ? FUNC_HASH_CONV : FUNC_HASH_MAIN;
			window.location.hash = selectedList[selectedIndex];
		}

		funcChangeTab(selectedIndex, listType);
	};

	/** 탭 클릭 함수 */
	const funcClickTab = (index: number, listType: 'main' | 'conv') => {
		const selectedList = listType === 'main' ? FUNC_HASH_MAIN : FUNC_HASH_CONV;
		window.location.hash = selectedList[index];
	};

	/** 탭 변경 함수 */
	const funcChangeTab = (index: number, listType: 'main' | 'conv') => {
		removeMainClass();

		disabledActiveTab(funcSelectedIndexRef.current);
		disabledContentsList(funcSelectedIndexRef.current);
		disabledSubList(funcSelectedIndexRef.current);

		funcSelectedIndexRef.current = index;
		currentListTypeRef.current = listType;

		addMainClass(index, listType);
		enabledActiveTab(index);
		enabledContentsList(index);
		enabledSubList(index);
	};

	/**  메인 클래스 추가해주는 함수 */
	const addMainClass = (index: number, listType: 'main' | 'conv') => {
		const className = listType === 'main' ? FUNC_HASH_MAIN[index] : FUNC_HASH_CONV[index];
		const element = document.querySelector('.function');
		if (element && className) {
			element.classList.add(className);
		}
	};

	/**  메인 클래스 삭제하는 함수 */
	const removeMainClass = () => {
		const element = document.querySelector('.function');
		if (element) {
			[...FUNC_HASH_MAIN, ...FUNC_HASH_CONV].forEach(className => {
				element.classList.remove(className);
			});
		}
	};

	/**  탭 활성화 해주는 함수 */
	const enabledActiveTab = (index: number) => {
		const tabButtons = document.querySelectorAll('.function .sub-tab .tab-btn');
		if (tabButtons[index]) {
			tabButtons[index].classList.add('active');
		}
	};

	/**  탭 비활성화 해주는 함수 */
	const disabledActiveTab = (index: number) => {
		const tabButtons = document.querySelectorAll('.function .sub-tab .tab-btn');
		if (tabButtons[index]) {
			tabButtons[index].classList.remove('active');
		}
	};

	/** 컨텐츠 리스트를 활성화 해주는 함수 */
	const enabledContentsList = (index: number) => {
		const contentLists = document.querySelectorAll('.function .content-list');
		if (contentLists[index]) {
			contentLists[index].classList.add('active');
		}
	};

	/** 컨텐츠 리스트를 비활성화 해주는 함수 */
	const disabledContentsList = (index: number) => {
		const contentLists = document.querySelectorAll('.function .content-list');
		if (contentLists[index]) {
			contentLists[index].classList.remove('active');
		}
	};

	/** 서브 리스트를 활성화 */
	const enabledSubList = (index: number) => {
		const subLists = document.querySelectorAll('.function .sub-list');
		if (subLists[index]) {
			subLists[index].classList.add('active');
		}
	};

	/** 서브 리스트를 비활성화 */
	const disabledSubList = (index: number) => {
		const subLists = document.querySelectorAll('.function .sub-list');
		if (subLists[index]) {
			subLists[index].classList.remove('active');
		}
	};

	useEffect(() => {
		funcChangeHashHandler();
		window.addEventListener('hashchange', funcChangeHashHandler);
		return () => {
			window.removeEventListener('hashchange', funcChangeHashHandler);
		};
	}, []);

	return {
		funcClickTab
	};
};

export default useTabManager;
